export const homeConstant = {
  GET_fAQ_REQUEST: "GET_fAQ_REQUEST",
  GET_fAQ_SUCCESS: "GET_fAQ_SUCCESS",
  GET_fAQ_FAILURE: "GET_fAQ_FAILURE",

  TOP_BANNER_REQUEST: "TOP_BANNER_REQUEST",
  TOP_BANNER_SUCCESS: "TOP_BANNER_SUCCESS",
  TOP_BANNER_FAILURE: "TOP_BANNER_FAILURE",

  CONTACT_REQUEST: "CONTACT_REQUEST",
  CONTACT_SUCCESS: "CONTACT_SUCCESS",
  CONTACT_FAILURE: "CONTACT_FAILURE",

  CAR_REGISTER_FORM_REQUEST: "CAR_REGISTER_FORM_REQUEST",
  CAR_REGISTER_FORM_SUCCESS: "CAR_REGISTER_FORM_SUCCESS",
  CAR_REGISTER_FORM_FAILURE: "CAR_REGISTER_FORM_FAILURE",
};
